// src/utils/platformNotificationTemplates.js
export const PLATFORM_NOTIFICATION_PARAMS = {
    BuyGoods: [
      "orderid={ORDERID}",
      "amount={COMMISSION_AMOUNT}",
      "cy=USD",
      "status=approved",
      "product={PRODUCT_CODENAME}",
      "conv_type={CONV_TYPE}",
      "click_id={SUBID}",
      "trackid={SUBID2}",
      "subid3={SUBID3}",
      "subid4={SUBID4}",
      "subid5={SUBID5}",
    ],
    AdCombo: [
      "orderid={trans_id}",
      "product={offer_id}",
      "amount={revenue}",
      "currency=USD",
      "status={status}",
      "goal={goal}",
      "subacc={subacc}",
      "subacc2={subacc2}",
      "subacc3={subacc3}",
      "click_id={subacc4}",
    ],
    Cartpanda: [
      "orderid={order_id}",
      "amount={amount_affiliate}",
      "cy={currency}",
      "conv_type={transaction_type}",
      "order_type={order_type}",
      "product={product_name}",
      "trackid={cid}",
      "click_id={gclid}",
      "subid1={sid1}",
      "subid2={sid2}",
      "subid3={sid3}",
      "subid4={sid4}",
    ],
    ClickBank: [
      ,
    ],
    Digistore24: [
      "orderid={transaction_id}",
      "amount={amount_affiliate}",
      "cy={currency}",
      "status={billing_status}",
      "transaction_type={transaction_type}",
      "order_type={order_type}",
      "product={product_name}",
      "subid1={sid1}",
      "subid2={sid2}",
      "subid3={sid3}",
      "subid4={sid4}",
      "subid5={sid5}",
      "click_id={cid}",
    ],
    JVZoo: [
    ],
    MaxWeb: [
      "orderid={ORDERID}",
      "amount={COMMISSION_AMOUNT}",
      "cy=USD",
      "product={PRODUCT_CODENAME}",
      "conv_type=Purchase",
      "subid={SUBID}",
      "subid2={SUBID2}",
      "subid3={SUBID3}",
      "subid4={SUBID4}",
      "subid5={SUBID5}",
    ],
    MediaScalers: [
      "orderid={transaction_id}",
      "amount={payout_amount}",
      "cy={offer_currency}",
      "status={status}",
      "product={offer_name}",
      "subid1={sub1}",
      "subid2={sub2}",
      "subid3={sub3}",
      "subid4={sub4}",
      "subid5={sub5}",
    ],
    SmartAdv: [
      "orderid={transaction_id}",
      "amount={payout_amount}",
      "cy={offer_currency}",
      "status={status}",
      "product={offer_name}",
      "subid1={sub1}",
      "subid2={sub2}",
      "subid3={sub3}",
      "subid4={sub4}",
      "subid5={sub5}",
    ],
    Webvork: [
      "orderid={lead_guid}",
      "status={status_lead}",
      "subid1={utm_medium}",
      "subid2={utm_campaign}",
      "subid3={utm_content}",
      "subid4={utm_term}",
      "amount={money}",
      "cy={currency}",
    ],
  };
  